/**
 * Checks whether a self-signup link has expired (client-side).
 *
 * @param {number|string|null|undefined} expireUntil - unix seconds, or null/undefined/"null" for never
 * @returns {boolean}
 *
 * @created_at 29/09/2026 by AI (Composer)
 */
export function isLinkExpired(expireUntil) {
	if (expireUntil == null || expireUntil === 'null' || expireUntil === '') {
		return false;
	}
	const expireUnixSeconds = Number(expireUntil);
	if (isNaN(expireUnixSeconds)) {
		return false;
	}
	const nowUnixSeconds = Math.floor(Date.now() / 1000);
	return nowUnixSeconds >= expireUnixSeconds;
}
